import { Search, Refresh, Delete, Edit, Cancel } from '@mui/icons-material';
import { Box, Grid, Typography, TextField, Tooltip, IconButton, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button, TablePagination, Dialog, DialogContent, DialogContentText, Snackbar, Alert, SelectChangeEvent, Stack, Autocomplete } from '@mui/material';
import React, { Component } from 'react'
import { GridTable } from '../Sidebar/SidebarStyles';
import CheckIcon from '@mui/icons-material/Check';
import { ActivateorDeactivateAdStpMaster, AddAutoDispatcherStpMaster, GetAutoDispatcherStpMaster, getbroker, MasterDeleteAdStpMaster, UpdateAutoDispatcherStpMaster, UpdateIgnoreStp } from '../ApiSevices/UserMasterApis';
import { getTemplateList } from '../ApiSevices/ChecklistTempApi';
import { fetchAllLobs } from '../ApiSevices/FileUploadApis';
import { green, red } from "@mui/material/colors";
import AddStpMaster from './StpAdd';
import ConfirmationDialogComponent from '../Common/ConfirmationDialogComponent';
import { ExportAutoDispatchSTP } from '../ApiSevices/ReportApis';

interface State {
    rows: any[];
    page: number;
    rowsPerPage: number;
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
    loading: boolean;
    searchTerm: string;
    searchQuery: string;
    decodedTokenJson: any,
    jobs: any[];
    brokerId: number;
    templateId: number;
    brokerList: { value: number; label: string }[];
    templateList: { value: number; label: string }[];
    totalCount: number;
    lobList: { label: string, value: string }[];
    selectedLobName: string;
    isOpenEditDialog: boolean;
    selectedRowForEdit: any;
    isAddPopupOpen: boolean;
    error: string;
    confirmationDialog: {
        isOpen: boolean,
        recordId: number,
        message: string,
        activate: boolean,
        isDelete?: boolean,
        isIgnore: boolean,
        isActivateOrDeactivate: boolean
    }
}

interface TableProps {
    displaysidebar: boolean;
}

interface Data {
    Id: number;
    BrokerId: number;
    TemplateName: string;
    CarrierName: string;
    LobCode: string;
    ArEnabled: boolean;
    MsdEnabled: boolean;
    SsdEnabled: boolean;
    EnableArAutoDispatch: boolean;
    EnableMsdAutoDispatch: boolean;
    EnableSsdAutoDispatch: boolean;
    IncludeEndorsement: boolean;
    IsActive: boolean;
    Metadata: string | null; // change type if Metadata is an object
    IgnoreStp: boolean; // change type if Metadata is an object
    Action: string | null; // change type if Metadata is an object
}

interface HeadCell {
    id: keyof Data;
    label: string;
    disableSort?: boolean;
}

export default class StpMaster extends Component<TableProps, State> {
    constructor(props: TableProps) {
        super(props)
        this.state = {
            page: 0,
            rowsPerPage: 100,
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'info',
            loading: false,
            searchTerm: '',
            searchQuery: '',
            decodedTokenJson: null,
            jobs: [],
            rows: [],
            totalCount: 0,
            brokerId: 0,
            brokerList: [],
            templateId: 0,
            templateList: [],
            lobList: [],
            selectedLobName: '',
            isOpenEditDialog: false,
            selectedRowForEdit: null,
            isAddPopupOpen: false,
            error: "",
            confirmationDialog: {
                isOpen: false,
                recordId: 0,
                message: "",
                activate: false,
                isIgnore: false,
                isActivateOrDeactivate: false
            }
        };
    }

    async componentDidMount(): Promise<void> {
        await this.loadInitialData();
        // this.loadInitialData();
    }

    loadInitialData = async () => {
        this.setState({ loading: true });

        try {
            await Promise.all([
                this.fetchBrokers(),
                this.fetchTemplates(),
                this.fetchAllLob(),
                this.fetchStpMaster()
            ]);
        } catch (error) {
            console.error("Error loading initial data:", error);
            this.showSnackbar("Failed to load initial data", "error");
        } finally {
            this.setState({ loading: false });
        }
    };

    fetchBrokers = async () => {
        try {
            const brokerData = await getbroker();
            this.setState({ brokerList: brokerData?.map((e: any) => ({ label: e.vchBrokerName, value: e.Broker_ID })) });
        } catch (error) {
            console.error('Error fetching brokers:', error);
        }
    };

    fetchTemplates = async () => {
        try {
            const templateData = await getTemplateList();
            this.setState({
                templateList: templateData?.map((e: any) => { return { label: e?.VCH_CHECKLIST, value: e?.ID } })
            })
        } catch (error) {
            console.error('Error fetching brokers:', error);
        }
    };

    fetchAllLob = async () => {
        try {
            const lobData = await fetchAllLobs();
            this.setState({
                lobList: lobData?.map((Lob: any) => ({ label: Lob?.Lob_Name, value: Lob.Lob_Code }))
            })
        } catch (error) {
            console.error('Error fetching brokers:', error);
        }
    };

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleBrokerChange = (event: SelectChangeEvent<number>) => {
        const selectedBrokerId = parseInt(event.target.value as string, 10);
        this.setState({ brokerId: selectedBrokerId, page: 0 });
    };

    async fetchStpMaster() {
        this.setState({ loading: true });
        const { page, rowsPerPage, brokerId, templateId, selectedLobName, templateList, lobList } = this.state;
        try {
            const response = await GetAutoDispatcherStpMaster(page, rowsPerPage, brokerId ?? undefined, templateList.find(tem => tem.value === templateId)?.label, lobList.find(lob => lob.label === selectedLobName)?.value)
            this.setState({
                rows: response.data,
                totalCount: response.totalCount
            });
        }
        catch {

        } finally {
            this.setState({ loading: false });
        }
    }

    handleSearchClick = async () => {
        this.setState({
            page: 0
        }, async () => {
            try {
                this.fetchStpMaster();
            } catch (error) {
                console.error('Error in searching:', error);
                this.showSnackbar('Failed to search.', 'error');
            } finally {
            }
        });
    };

    handleChangePage = (_: unknown, newPage: number) => {
        this.setState({ page: newPage }, () => {
            this.fetchStpMaster();
        });
    };

    handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        this.setState({ rowsPerPage: newRowsPerPage, page: 0 });
    };

    handleClose() {
        this.setState({ isOpenEditDialog: false, selectedRowForEdit: null });
    }

    handleAddPopupClose() {
        this.setState({ isAddPopupOpen: false });
    }

    async handleAddSubmit(form: any) {
        this.setState({ loading: true })
        try {
            console.log(form);
            const response = await AddAutoDispatcherStpMaster({ ...form, lobCode: this.state.lobList.find(lob => lob.label === form.lobCode)?.value });
            if (response?.status === 200) {
                this.showSnackbar('Added Successfully', "success");
                this.handleAddPopupClose();
                this.fetchStpMaster();
            } else {
                this.showSnackbar("Duplicate record already exists.", "error");
            }
        } catch (error) {
            console.error('Error in searching:', error);
            this.showSnackbar('Failed to add', "error");
        } finally {
            this.setState({ loading: false });
        }
    }

    async handleEditConfirm() {
        this.setState({ loading: true });
        try {
            const response = await UpdateAutoDispatcherStpMaster({ id: this.state.selectedRowForEdit?.Id, carrierName: this.state.selectedRowForEdit.CarrierName });
            if (response?.status === 200) {
                this.showSnackbar("Carrier Name Update successfully", "success");
                this.resetEditPopup();
                this.fetchStpMaster();
            }
        } catch (error) {
            console.error("Error Updating Carrier Name:", error);
            this.showSnackbar("Failed Updating Carrier Name", "error");
        } finally {
            this.setState({ loading: false });
        }
    }

    resetEditPopup() {
        this.setState({ isOpenEditDialog: false, selectedRowForEdit: null });
    }

    onConfirmationDialog = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            if (this.state.confirmationDialog.isDelete) {
                await MasterDeleteAdStpMaster(this.state.confirmationDialog.recordId)
            }
            else if (this.state.confirmationDialog.isIgnore) {
                await UpdateIgnoreStp(this.state.confirmationDialog.recordId, this.state.confirmationDialog.activate);
            }
            else if (this.state.confirmationDialog.isActivateOrDeactivate) {
                await ActivateorDeactivateAdStpMaster(this.state.confirmationDialog.recordId, this.state.confirmationDialog.activate);
            }
            await this.fetchStpMaster();
            this.setState({
                confirmationDialog: {
                    isOpen: false,
                    recordId: 0,
                    message: "",
                    activate: false,
                    isDelete: false,
                    isIgnore: false,
                    isActivateOrDeactivate: false
                }
            });
        } catch (e) {
            this.showSnackbar("Failed Updating Carrier Name", "error");
        }
        finally {
            this.setState({ loading: false });
        }
    }

    handleExportExcel = async () => {
        this.setState({ loading: true });
        try {
            const fileBlob = await ExportAutoDispatchSTP();

            const url = window.URL.createObjectURL(fileBlob);
            const link = document.createElement('a');
            link.href = url;

            const filename = `AutoDispatchSTP_${new Date().toISOString().replace(/[:.]/g, '')}.xlsx`;
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting Auto job Stp:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { loading, rowsPerPage, rows, page, totalCount, snackbarMessage, snackbarOpen, snackbarSeverity, isOpenEditDialog, selectedRowForEdit, isAddPopupOpen, confirmationDialog } = this.state;
        const { displaysidebar } = this.props;

        const headCells: HeadCell[] = [
            { id: 'BrokerId', label: 'Broker Id', disableSort: false },
            { id: 'TemplateName', label: 'Template Name', disableSort: false },
            { id: 'LobCode', label: 'LOB Code', disableSort: false },
            { id: 'ArEnabled', label: 'AR Enabled', disableSort: false },
            { id: 'MsdEnabled', label: 'MSD Enabled', disableSort: false },
            { id: 'SsdEnabled', label: 'SSD Enabled', disableSort: false },
            // { id: 'EnableArAutoDispatch', label: 'Enable AR Auto Dispatch', disableSort: false },
            // { id: 'EnableMsdAutoDispatch', label: 'Enable MSD Auto Dispatch', disableSort: false },
            // { id: 'EnableSsdAutoDispatch', label: 'Enable SSD Auto Dispatch', disableSort: false },
            { id: 'IncludeEndorsement', label: 'Include Endorsement', disableSort: false },
            { id: 'IsActive', label: 'Is Active', disableSort: false },
            { id: 'Metadata', label: 'Metadata', disableSort: true },
            { id: 'IgnoreStp', label: 'Ignore STP', disableSort: true },
            { id: 'Action', label: 'Action', disableSort: true }
        ];
        const visibleHeadCells = headCells;

        const rowsWithSerialNumber = rows?.map((row, index) => {
            return {
                ...row,
                sNo: page * rowsPerPage + index + 1,
            };
        });

        const sortedRows = rowsWithSerialNumber;

        const showNoJobsMessage = sortedRows.length === 0;

        const columnWidths: Partial<Record<keyof Data, number>> = {
            BrokerId: 100,
            TemplateName: 160,
            LobCode: 100,
            ArEnabled: 100,
            MsdEnabled: 100,
            SsdEnabled: 100,
            EnableArAutoDispatch: 100,
            EnableMsdAutoDispatch: 160,
            EnableSsdAutoDispatch: 100,
            IncludeEndorsement: 160,
            IsActive: 100,
            Metadata: 100,
            IgnoreStp: 100,
            Action: 200
        };

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div> {/* Your loader component or custom CSS */}
                    </Box>
                )}

                <GridTable displaysidebar={displaysidebar}>
                    <div>
                        <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                            {/* Left side: Broker and Status */}
                            <Grid item>
                                <Box display="flex" gap={2} alignItems="center">
                                    {/* Broker Name Dropdown */}
                                    <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                                        <Typography
                                            variant="body2"
                                            sx={{ mb: 0.5, fontWeight: '500', }}
                                        >
                                            Select Broker
                                        </Typography>
                                        <Autocomplete
                                            options={this.state.brokerList}
                                            getOptionLabel={(option) => option?.label || ''}
                                            value={this.state.brokerList.find((e: any) => e.value === this.state.brokerId) || null}
                                            onChange={(event, newValue) => {
                                                this.setState({ brokerId: newValue?.value || 0 });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Select Broker..."
                                                    size="medium"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        style: { height: 25, fontSize: "11px" }
                                                    }}
                                                />
                                            )}
                                            fullWidth
                                            slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                                        />
                                    </div>

                                    <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: '500' }}>
                                            Select Template
                                        </Typography>
                                        <Autocomplete
                                            options={this.state.templateList}
                                            getOptionLabel={(option) => option?.label || ''}
                                            value={this.state.templateList.find((e: any) => e.value === this.state.templateId) || null}
                                            onChange={(event, newValue) => {
                                                this.setState({ templateId: newValue?.value || 0 });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Select Template..."
                                                    size="medium"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        style: { height: 25, fontSize: "11px" }
                                                    }}
                                                />
                                            )}
                                            fullWidth
                                            slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                                        />
                                    </div>
                                    <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                                        <Typography
                                            variant="body2"
                                            sx={{ mb: 0.5, fontWeight: 500 }}
                                        >
                                            Select Lob
                                        </Typography>
                                        <Autocomplete
                                            options={this.state.lobList}
                                            getOptionLabel={(option) => option?.label || ''}
                                            value={this.state.lobList.find((e: any) => e.label === this.state.selectedLobName) || null}
                                            onChange={(event, newValue) => {
                                                this.setState({ selectedLobName: newValue?.label?.toString() || "" });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Select LOB..."
                                                    size="medium"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        style: { height: 25, fontSize: "11px" }
                                                    }}
                                                />
                                            )}
                                            fullWidth
                                            slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                                        />
                                    </div>

                                    <Box display="flex" alignItems="center" gap={0} sx={{ mt: 3 }}>
                                        <Tooltip title="Click here for search result">
                                            <IconButton
                                                onClick={this.handleSearchClick}
                                                sx={{ mr: 1.5, height: '33px', border: '0.2px solid #d0bcbca1', borderRadius: '9%' }}
                                            >
                                                <Search fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        {/* <Button sx={{ color: 'black' }} onClick={() => this.setState({ isAddPopupOpen: true })}>
                                            Add
                                        </Button> */}
                                        <div style={{ gap: '10px', display: 'flex' }}>
                                            <button
                                                style={{ height: "25px", padding: "0 20px", backgroundColor: "#1976d2", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "12px" }}
                                                onClick={() => this.setState({ isAddPopupOpen: true })}
                                            >Add</button>

                                            <button
                                                style={{ height: "25px", padding: "0 20px", backgroundColor: "#1976d2", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", fontSize: "12px" }}
                                                onClick={() => this.handleExportExcel()}
                                            >Export as Excel</button>
                                        </div>
                                    </Box>
                                </Box>
                            </Grid>

                            {/* Right side: Search + Refresh */}
                            <Grid item>
                                <Box display="flex" alignItems="center" gap={1}>
                                    {/* Refresh Icon */}
                                    <Box sx={{ marginTop: '26px' }}>
                                        <Tooltip title="Click here to refresh the table">
                                            <span>
                                                <Refresh
                                                    sx={{
                                                        cursor: 'pointer',
                                                        color: 'blue',
                                                        border: '0.1px solid black',
                                                        borderRadius: '4px',
                                                        padding: '3px',
                                                        height: 30,
                                                        width: 30,
                                                        mr: 1.5,
                                                        mt: 0.1,
                                                        boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 8px',
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            templateId: 0,
                                                            brokerId: 0,
                                                            selectedLobName: '',
                                                            page: 0,
                                                        }, () => {
                                                            this.fetchStpMaster();
                                                        });
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                            <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
                                <TableContainer sx={{ minWidth: 'max-content' }}>
                                    <Table stickyHeader sx={{ height: '50px' }} size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold' }}>S.No</TableCell>
                                                {visibleHeadCells?.map((headCell) => (
                                                    //   <TableCell
                                                    //     key={headCell.id}
                                                    //     sortDirection={
                                                    //         headCell.disableSort ? false : orderBy === headCell.id ? order : false
                                                    //     }
                                                    //     sx={{ fontSize: '11px', width: 190 }}
                                                    // >
                                                    //     {headCell.disableSort ? (
                                                    //         headCell.label
                                                    //     ) : (
                                                    //         <TableSortLabel
                                                    //             active={orderBy === headCell.id}
                                                    //             direction={orderBy === headCell.id ? order : 'asc'}
                                                    //             onClick={(event) => this.handleRequestSort(event, headCell.id)}
                                                    //         >
                                                    //             {headCell.label}
                                                    //         </TableSortLabel>
                                                    //     )}
                                                    <TableCell
                                                        key={headCell.id.toString()}
                                                        sx={{
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            textAlign: 'center',
                                                            width: columnWidths[headCell.id as keyof typeof columnWidths] || 190, // fallback width
                                                            minWidth: columnWidths[headCell.id as keyof typeof columnWidths] || 190
                                                        }}
                                                    >
                                                        {headCell.label}
                                                    </TableCell>
                                                ))}


                                                {/* <TableCell sx={{ fontSize: '11px', width: 130 }}>Status</TableCell>
                                                <TableCell sx={{ fontSize: '11px', width: 130 }}>Actions</TableCell>
                                                <TableCell sx={{ fontSize: '11px', width: 130 }}>Dispatch</TableCell>
                                                <TableCell sx={{ fontSize: '11px', width: 130 }}>UploadDiscrepancy</TableCell> */}
                                            </TableRow>
                                        </TableHead>

                                    </Table>

                                    <Box sx={{ maxHeight: 310, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                        <Table size="small">
                                            <TableBody>
                                                {showNoJobsMessage ? (
                                                    <TableRow>
                                                        <TableCell colSpan={headCells.length + 3} align="center"
                                                            sx={{
                                                                fontSize: '14px',
                                                                fontWeight: 500,
                                                                color: 'gray',
                                                                padding: '20px',
                                                                borderBottom: 'none',
                                                            }}>
                                                            No Records found for the selected status.
                                                        </TableCell>
                                                    </TableRow>
                                                ) :
                                                    sortedRows?.length === 0 ? (
                                                        <TableRow>
                                                            <TableCell colSpan={headCells.length + 3} align="center"
                                                                sx={{
                                                                    fontSize: '14px',
                                                                    fontWeight: 500,
                                                                    color: 'gray',
                                                                    padding: '20px',
                                                                    borderBottom: 'none',
                                                                }}>
                                                                No records to display
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        sortedRows?.map((row, index) => {
                                                            return (
                                                                <TableRow hover key={row.Id}>
                                                                    <TableCell sx={{ fontSize: '11px', width: 60 }}>
                                                                        {page * rowsPerPage + index + 1}
                                                                    </TableCell>

                                                                    {
                                                                        headCells.map(header => {
                                                                            if (header.id === "Action") {
                                                                                return (
                                                                                    <TableCell sx={{ fontSize: '11px', textAlign: "center",alignItems:"center", width: columnWidths[header.id] || 100 }}>
                                                                                        <div style={{ display: 'flex', gap: '10px',justifyContent:"center" }}>
                                                                                            <Tooltip title={`Click here to ${row.IsActive ? "Deactivate" : "Activate"}`}>
                                                                                                {
                                                                                                    row.IsActive ?
                                                                                                        <Cancel fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                                            this.setState({
                                                                                                                confirmationDialog: {
                                                                                                                    isOpen: true,
                                                                                                                    recordId: row.Id,
                                                                                                                    message: `Are you Sure you want to deactivate this record of S.No: ${page * rowsPerPage + index + 1}?`,
                                                                                                                    activate: false,
                                                                                                                    isIgnore: false,
                                                                                                                    isActivateOrDeactivate: true
                                                                                                                }
                                                                                                            });
                                                                                                        }} style={{ color: red[500] }} />
                                                                                                        :
                                                                                                        <CheckIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                                            this.setState({
                                                                                                                confirmationDialog: {
                                                                                                                    isOpen: true,
                                                                                                                    recordId: row.Id,
                                                                                                                    message: `Are you Sure you want to activate this record of S.No: ${page * rowsPerPage + index + 1}?`,
                                                                                                                    activate: true,
                                                                                                                    isIgnore: false,
                                                                                                                    isActivateOrDeactivate: true
                                                                                                                }
                                                                                                            });
                                                                                                        }} style={{ color: green[500] }} />
                                                                                                }
                                                                                            </Tooltip>
                                                                                            <Tooltip title={`Click here to Delete`}>
                                                                                                <Delete fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                                    this.setState({
                                                                                                        confirmationDialog: {
                                                                                                            isOpen: true,
                                                                                                            recordId: row?.Id,
                                                                                                            message: `Are you Sure you want to delete this record of S.No: ${page * rowsPerPage + index + 1}?`,
                                                                                                            activate: false,
                                                                                                            isDelete: true,
                                                                                                            isIgnore: false,
                                                                                                            isActivateOrDeactivate: false
                                                                                                        }
                                                                                                    });
                                                                                                }} />
                                                                                            </Tooltip>
                                                                                            <Tooltip title={`Click here to Edit`}>
                                                                                                <Edit fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                                    this.setState({ isOpenEditDialog: true, selectedRowForEdit: row });
                                                                                                }} />
                                                                                            </Tooltip>
                                                                                            <Tooltip title={`Click here to ${row.IgnoreStp ? "Enable STP" : "Disable STP"}`}>
                                                                                                {
                                                                                                    row.IgnoreStp ?
                                                                                                        <Cancel fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                                            this.setState({
                                                                                                                confirmationDialog: {
                                                                                                                    isOpen: true,
                                                                                                                    recordId: row.Id,
                                                                                                                    message: `Are you Sure you want to Enable STP for this record of S.No: ${page * rowsPerPage + index + 1}?`,
                                                                                                                    activate: false,
                                                                                                                    isIgnore: true,
                                                                                                                    isActivateOrDeactivate: false
                                                                                                                }
                                                                                                            });
                                                                                                        }} style={{ color: red[500] }} />
                                                                                                        :
                                                                                                        <CheckIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                                            this.setState({
                                                                                                                confirmationDialog: {
                                                                                                                    isOpen: true,
                                                                                                                    recordId: row.Id,
                                                                                                                    message: `Are you Sure you want to Disable STP for this record of S.No: ${page * rowsPerPage + index + 1}?`,
                                                                                                                    activate: true,
                                                                                                                    isIgnore: true,
                                                                                                                    isActivateOrDeactivate: false
                                                                                                                }
                                                                                                            });
                                                                                                        }} style={{ color: green[500] }} />
                                                                                                }
                                                                                            </Tooltip>
                                                                                        </div>
                                                                                    </TableCell>
                                                                                );
                                                                            }
                                                                            return (
                                                                                <TableCell sx={{ fontSize: '11px', textAlign: "center", width: columnWidths[header.id] || 100 }}>
                                                                                    {row[header.id]?.toString()}
                                                                                </TableCell>
                                                                            )
                                                                        })
                                                                    }

                                                                </TableRow>
                                                            );
                                                        })
                                                    )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </TableContainer>
                            </Box>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                component="div"
                                count={totalCount}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </Paper>
                    </div>
                </GridTable>



                {/* Edit popup */}
                <Dialog open={isOpenEditDialog} onClose={(event, reason) => {
                    if (reason === "backdropClick" || reason === "escapeKeyDown") {
                        return;
                    }
                    this.handleClose()
                }}>
                    <DialogContent sx={{
                        padding: '0px 20px',
                        paddingTop: '25px',
                        paddingBottom: '35px',
                        textAlign: 'center',
                    }}>
                        <DialogContentText sx={{ textAlign: 'center', mt: 1, mb: 3, fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.7)' }}>
                            {/* Top Section */}
                            <Grid container spacing={2}>
                                {/* Left Section */}
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <Stack spacing={0.5}>
                                            <Stack direction="row" alignItems="center">
                                                <Typography fontSize={12} fontWeight={600} minWidth={100}>
                                                    Broker ID:
                                                </Typography>
                                                <Typography fontSize={10} color="text.secondary">
                                                    {selectedRowForEdit?.BrokerId}
                                                </Typography>
                                            </Stack>

                                            <Stack direction="row" alignItems="center">
                                                <Typography fontSize={12} fontWeight={600} minWidth={100}>
                                                    Template:
                                                </Typography>
                                                <Typography fontSize={10} color="text.secondary">
                                                    {selectedRowForEdit?.TemplateName}
                                                </Typography>
                                            </Stack>

                                            <Stack direction="row" alignItems="center">
                                                <Typography fontSize={12} fontWeight={600} minWidth={100}>
                                                    Lob Code:
                                                </Typography>
                                                <Typography fontSize={10} color="text.secondary">
                                                    {selectedRowForEdit?.LobCode}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Box>
                                </Grid>

                                {/* Right Section */}
                                <Grid item xs={12} md={6}>
                                    <Box>
                                        <Stack spacing={0.5}>
                                            <Stack direction="row" alignItems="center">
                                                <Typography fontSize={12} fontWeight={600} minWidth={100}>
                                                    AR Enabled:
                                                </Typography>
                                                <Typography fontSize={10} color="text.secondary">
                                                    {selectedRowForEdit?.ArEnabled ? "Yes" : "No"}
                                                </Typography>
                                            </Stack>

                                            <Stack direction="row" alignItems="center">
                                                <Typography fontSize={12} fontWeight={600} minWidth={100}>
                                                    SSD Enabled:
                                                </Typography>
                                                <Typography fontSize={10} color="text.secondary">
                                                    {selectedRowForEdit?.SsdEnabled ? "Yes" : "No"}
                                                </Typography>
                                            </Stack>

                                            <Stack direction="row" alignItems="center">
                                                <Typography fontSize={12} fontWeight={600} minWidth={100}>
                                                    MSD Enabled:
                                                </Typography>
                                                <Typography fontSize={10} color="text.secondary" >
                                                    {selectedRowForEdit?.MsdEnabled ? "Yes" : "No"}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Box>

                                </Grid>
                            </Grid>

                            {/* Bottom Section */}
                            <Box
                                sx={{
                                    p: 2,
                                    borderRadius: 1,
                                    mt: 2
                                }}
                            >
                                <Typography>
                                    <Typography
                                        variant="body2"
                                        sx={{ mb: 0.5, fontWeight: 'bold', textAlign: 'left' }}
                                    >
                                        Carrier Name
                                    </Typography>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        rows={4}
                                        value={selectedRowForEdit?.CarrierName}
                                        onChange={(event) => {
                                            this.setState({
                                                selectedRowForEdit: {
                                                    ...selectedRowForEdit,
                                                    CarrierName: event.target.value
                                                }
                                            });
                                        }}
                                        sx={{
                                            width: 350,
                                            mb: 2,
                                            '& .MuiOutlinedInput-input': {
                                                fontSize: '12px',
                                            },
                                            '& .MuiInputBase-root': {
                                                fontSize: '12px',
                                            },
                                            '& textarea': {
                                                overflow: 'auto',
                                                resize: 'none',
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#ccc',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#1976d2',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#1976d2',
                                                },
                                            },
                                            '& textarea::placeholder': {
                                                color: '#999',
                                                fontStyle: 'italic',
                                                opacity: 1,
                                                fontSize: '12px'
                                            }
                                        }}
                                    />
                                </Typography>
                            </Box>
                        </DialogContentText>
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    px: 4,
                                    borderRadius: '6px',
                                }}
                                onClick={() => this.handleEditConfirm()}
                            >
                                Confirm
                            </Button>
                            <Button
                                onClick={() => this.handleClose()}
                                sx={{
                                    color: '#007bff',
                                    borderColor: '#007bff',
                                    border: '0.5px solid #53494987',
                                    px: 4,
                                    borderRadius: '6px',
                                    '&:hover': {
                                        borderColor: '#0056b3',
                                        color: '#0056b3',
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </DialogContent>
                </Dialog >

                {isAddPopupOpen &&
                    <AddStpMaster
                        open={isAddPopupOpen}
                        onClose={() => this.handleAddPopupClose()}
                        handleSubmit={this.handleAddSubmit.bind(this)}
                        brokerList={this.state.brokerList}
                        templateList={this.state.templateList}
                        lobList={this.state.lobList}
                    />
                }

                <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
                    this.setState({
                        confirmationDialog: {
                            isOpen: false,
                            recordId: 0,
                            message: "",
                            activate: false,
                            isDelete: false,
                            isIgnore: false,
                            isActivateOrDeactivate: false
                        }
                    });
                }} />

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2500}
                    onClose={() => this.setState({ snackbarOpen: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={() => this.setState({ snackbarOpen: false })} severity={snackbarSeverity} sx={{ width: "100%" }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </>
        );
    }
}
